package com.essntl.features.category.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.category.domain.usecase")
class AddEditCategoryUseCaseModule